import fetch from "isomorphic-fetch";
import { getHeaders } from "./http";
import { getPrintableAwsUploadSigninUrl } from "../apis";
import imageCompression from "browser-image-compression";

export const highResOptions = {
  maxSizeMB: 10,
  maxWidthOrHeight: 3000,
  useWebWorker: true,
};

export async function scaleImageFile(file, scalingOptions) {
  const compressedFile = await imageCompression(file, scalingOptions);
  return compressedFile;
}

export const aws_file_info = (file_url) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await fetch(file_url, {
        method: "HEAD",
        headers: getHeaders(null, null, { include_content_type: false }),
      });

      if (res.ok) {
        const s3_bytes = res.headers.get("Content-Length");
        resolve({ s3_bytes });
      } else {
        reject({ reason: "aws_file_info_failed", error: res });
      }
    } catch (error) {
      reject({ reason: "aws_file_info_error", error });
    }
  });
};

export const upload_to_aws_directly = (file, country_code) => {
  return new Promise(async (resolve, reject) => {
    let signInData;
    try {
      const result = await getPrintableAwsUploadSigninUrl(
        country_code,
        file.name,
      );
      signInData = result.data;
    } catch (errAwsSignInUrl) {
      reject({ reason: "aws_signin_url_error", error: errAwsSignInUrl });
      return;
    }

    let {
      s3_filepath,
      pre_signin_res: presigned_post_data,
      aws_file_url,
    } = signInData;

    let aws_pre_signin_url = presigned_post_data.url;
    let aws_upload_img_form_data = new window.FormData();

    Object.keys(presigned_post_data.fields).forEach((key) => {
      aws_upload_img_form_data.append(key, presigned_post_data.fields[key]);
    });
    aws_upload_img_form_data.append("file", file);

    try {
      const res = await fetch(aws_pre_signin_url, {
        method: "POST",
        headers: getHeaders(null, null, { include_content_type: false }),
        body: aws_upload_img_form_data,
      });

      if (res.ok) {
        resolve({ s3_filepath, aws_file_url });
      } else {
        reject({ reason: "aws_upload_failed", error: res });
      }
    } catch (error) {
      reject({ reason: "aws_upload_error", error });
    }
  });
};
